export const LANDING = {
  // Header
  headerLogo: "header-logo",
  navFeatures: "nav-features",
  navHowItWorks: "nav-how-it-works",
  navFaq: "nav-faq",
  navCtaButton: "nav-cta-button",

  // Hero
  heroHeading: "hero-heading",
  heroSubheading: "hero-subheading",
  heroEmailInput: "hero-email-input",
  heroNameInput: "hero-name-input",
  heroSubmitButton: "hero-submit-button",
  heroImage: "hero-image",
  heroSuccessMessage: "hero-success-message",
  heroErrorMessage: "hero-error-message",

  // Features
  featureShopping: "feature-shopping",
  featureRecipes: "feature-recipes",
  featurePlanning: "feature-planning",
  featurePantry: "feature-pantry",

  // How it works
  step1: "step-1",
  step2: "step-2",
  step3: "step-3",

  // FAQ
  faqItem: "faq-item",

  // Final CTA
  finalCtaButton: "final-cta-button",

  // Footer
  footerPrivacyLink: "footer-privacy-link",
  footerDeletionLink: "footer-deletion-link",
  footerImpressumLink: "footer-impressum-link",
  footerContactLink: "footer-contact-link",
};

export const DATENSCHUTZ = {
  page: "datenschutz-page",
  backToHome: "datenschutz-back-home",
};

export const KONTO_LOESCHEN = {
  page: "konto-loeschen-page",
  emailInput: "deletion-email-input",
  accountIdInput: "deletion-account-id-input",
  reasonInput: "deletion-reason-input",
  confirmCheckbox: "deletion-confirm-checkbox",
  submitButton: "deletion-submit-button",
  successMessage: "deletion-success-message",
  errorMessage: "deletion-error-message",
  backToHome: "deletion-back-home",
};

export const IMPRESSUM = {
  page: "impressum-page",
  backToHome: "impressum-back-home",
};

export const ADMIN = {
  loginPage: "admin-login-page",
  loginEmailInput: "admin-login-email",
  loginPasswordInput: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",

  dashboard: "admin-dashboard",
  tabSignups: "admin-tab-signups",
  tabDeletions: "admin-tab-deletions",
  logoutButton: "admin-logout",

  signupsTable: "admin-signups-table",
  signupsExportCsv: "admin-signups-export",
  signupRow: "admin-signup-row",
  signupResendEmail: "admin-signup-resend",
  signupDelete: "admin-signup-delete",

  deletionsTable: "admin-deletions-table",
  deletionsExportCsv: "admin-deletions-export",
  deletionRow: "admin-deletion-row",
  deletionMarkDone: "admin-deletion-mark-done",
  deletionMarkPending: "admin-deletion-mark-pending",

  statBoxSignups: "admin-stat-signups",
  statBoxDeletionsPending: "admin-stat-deletions-pending",
  statBoxEmailsSent: "admin-stat-emails-sent",

  // Content editor
  tabContent: "admin-tab-content",
  contentEditor: "admin-content-editor",
  contentSave: "admin-content-save",
  contentReset: "admin-content-reset",
  contentHeroImage: "admin-content-hero-image",
  contentFaqAdd: "admin-content-faq-add",
};
